import {Link} from '@shopify/hydrogen';
import clsx from 'clsx';
import Cart from '../cart/Cart.client';
import CartToggle from '../cart/CartToggle.client';
import CountrySelect from './CountrySelect.client';
import {UserIconSolid} from '../icons/UserSolid';

type Props = {
  countrySelect?: {
    title?: object;
    text?: object;
  };
};

/**
 * A server component that specifies the content of the header on the website
 */
export default function HeaderActions({countrySelect}: Props) {
  return (
    <>
      <div
        className={clsx(
          'absolute right-[40px] flex h-full items-center md:right-[30px]', //
          'md:right-0 md:mr-4',
        )}
      >
        {/* Country select */}
        <div>
          <CountrySelect content={countrySelect} />
        </div>
        {/* Account */}
        <Link
          className={clsx([
            'hidden aspect-square h-[2rem] items-center rounded-sm bg-darkGray bg-opacity-0 p-2 sm:mr-3 md:mr-0',
            'sm:flex',
            'hover:bg-opacity-10',
          ])}
          to="/account"
        >
          <UserIconSolid className={clsx('h-full w-full text-black')} />
        </Link>
        {/* Cart */}
        <CartToggle />
      </div>

      <Cart />
    </>
  );
}
